export const mobilePageConfig = {
  "pageShowType": "mobile",
  "title": "Date Comparison",
  "titleCN": "时间对比",
  "path": "/comparisonAnalysis/dateComparison",
  "defaultTab": "dateComparison",
  "tabList": [
    {
      "id": "dateComparison",
      "tabName": "Date Comparison",
      "tabNameCN": "时间对比",
      "isHaveNotification": true,
      "notificationPath": "/comparisonAnalysis/dateComparison",
      "path": "/comparisonAnalysis/dateComparison",
      "tabIcon": "",
      "logConfig": {
        "pageId": "201701",
        "pageName": "comparisonAnalysisDateComparison",
        "extInfo": "comparisonAnalysisDateComparison",
        "pagePath": "/comparisonAnalysis/dateComparison"
      },
      "filters": [
        {
          "data": {
            "dataFrame": "mobile"
          },
          "name": "DateFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/comparisonAnalysis/dateComparison",
          "componentList": [
            {
              "name": "dateComparisonTrendService",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/comparison_analysis/date/linechart",
                  "isDark": true
                }
              },
              "children": [
                {
                  "name": "SegmentMoreCo",
                  "className": "",
                  "style": {},
                  "type": "view",
                  "props": {
                    "config": {
                      "componentSegment": {
                        "Day": [
                          {
                            "value": "tru",
                            "metric_key": "total_users",
                            "enName": "TNU",
                            "cnName": "总注册用户数",
                            "rainbowKey": "",
                            "explainEn": "Total New Users. Total number of registered users accumulated to the statistical day (vopenid deduplicated).",
                            "explainCn": "累计至统计日的注册用户总数(vopenid数去重)。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "new",
                            "metric_key": "new_users",
                            "enName": "New",
                            "cnName": "新进用户",
                            "rainbowKey": "",
                            "explainEn": "New Register Users.Total number of newly-registered users in the statistical period (vopenid deduplicated).",
                            "explainCn": "统计周期内新注册用户数(vopenid数去重)。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "dau",
                            "metric_key": "active_users",
                            "enName": "DAU",
                            "cnName": "日活跃",
                            "rainbowKey": "",
                            "explainEn": "Daily Active Users.Number of users who have logged in to the game during the statistical period (userid deduplicated).",
                            "explainCn": "统计周期内登录过游戏的用户数(vopenid数去重)。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "revenue",
                            "metric_key": "pay_amount",
                            "enName": "Revenue($)",
                            "cnName": "付费金额($)",
                            "rainbowKey": "",
                            "explainEn": "Total player payment amount in statistical period, which does not include refund data, used the exchange rate from last-month settlement. This amount will deviate from the actual settlement of accounts this month for about 5% to 30%, due to the difference in exchange rate, timezone, billing amount. Please take note.",
                            "explainCn": "统计周期内玩家的付费金额总额，注：此收入不含退款数据，且采用汇率为财务上一月结算汇率，与实际财务结算会在汇率、时区、计费金额等情况上会有误差，误差在5%-30%不等，请知悉。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "pcu",
                            "metric_key": "pcu",
                            "enName": "PCU",
                            "cnName": "最高同时在线",
                            "rainbowKey": "",
                            "explainEn": "The highest number of users online simultaneously at each moment (every 5 minutes) of the day.",
                            "explainCn": "取当天各时刻（每5分钟打点）最高的同时在线用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "acu",
                            "metric_key": "acu",
                            "enName": "ACU",
                            "cnName": "平均同时在线",
                            "rainbowKey": "",
                            "explainEn": "The average number of users online simultaneously at each moment (every 5 minutes) of the day.",
                            "explainCn": "将当天内各时刻（每5分钟打点）的在线数进行平均统计",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "aot",
                            "metric_key": "aot",
                            "enName": "Avg.Playtime(min)",
                            "cnName": "平均在线时长(分钟)",
                            "rainbowKey": "",
                            "explainEn": "Daily: Daily Average Play Time.Total play time/Number of active users (min).\nWeekly: Weekly Average Play Time. Total play time/Weekly active users (min).\nMonthly: Monthly Average Play Time. Total play time/Monthly active users (min).",
                            "explainCn": "日平均在线时长=总在线时长/活跃用户数（单位：分钟\n周平均在线时长=周总在线时长/周活跃用户数（单位：分钟\n月平均在线时长=月总在线时长/月活跃用户数（单位：分钟）",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "d237",
                            "metric_key": "d2",
                            "enName": "D2",
                            "cnName": "次留",
                            "rainbowKey": "",
                            "explainEn": "The retention rate of new register users on day 2. Number of retained users on day N from XX (registration date) / Number of new users on XX (registration date). Registration date is day 1.",
                            "explainCn": "次留=xx注册日期第2天存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d3",
                            "metric_key": "d3",
                            "enName": "D3",
                            "cnName": "3留",
                            "rainbowKey": "",
                            "explainEn": "The retention rate of new register users on day 3. Registration date is day 1.",
                            "explainCn": "3留=xx注册日期第3天存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d4",
                            "metric_key": "d4",
                            "enName": "D4",
                            "cnName": "4留",
                            "rainbowKey": "",
                            "explainEn": "The retention rate of new register users on day 4.Registration date is day 1.",
                            "explainCn": "4留=xx注册日期第4天存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d5",
                            "metric_key": "d5",
                            "enName": "D5",
                            "cnName": "5留",
                            "rainbowKey": "",
                            "explainEn": "The retention rate of new register users on day 5.Registration date is day 1.",
                            "explainCn": "5留=xx注册日期第5天存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d6",
                            "metric_key": "d6",
                            "enName": "D6",
                            "cnName": "6留",
                            "rainbowKey": "",
                            "explainEn": "The retention rate of new register users on day 6. Registration date is day 1.",
                            "explainCn": "6留=xx注册日期第6天存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d7",
                            "metric_key": "d7",
                            "enName": "D7",
                            "cnName": "7留",
                            "rainbowKey": "",
                            "explainEn": "The retention rate of new register users on day 7.",
                            "explainCn": "7留=xx注册日期第7天存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "active_retention_d2",
                            "metric_key": "active_retention_d2",
                            "enName": "Active Retention D2",
                            "cnName": "活跃次留",
                            "rainbowKey": "",
                            "explainEn": "Active retention D2 = the percentage of players that played the game on this day and returned to the game 2 days later, Active date is D0.",
                            "explainCn": "D2 活跃留存率 = 首次玩了游戏的活跃玩家在2天后返回游戏的比例，其中活跃日期为 D0。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "active_retention_d3",
                            "metric_key": "active_retention_d3",
                            "enName": "Active Retention D3",
                            "cnName": "活跃3留",
                            "rainbowKey": "",
                            "explainEn": "Active retention D3 = the percentage of players that played the game on this day and returned to the game 3 days later, Active date is D0.",
                            "explainCn": "D3 活跃留存率 = 首次玩了游戏的活跃玩家在3天后返回游戏的比例，其中活跃日期为 D0。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "active_retention_d7",
                            "metric_key": "active_retention_d7",
                            "enName": "Active Retention D7",
                            "cnName": "活跃7留",
                            "rainbowKey": "",
                            "explainEn": "Active retention D7 = the percentage of players that played the game on this day and returned to the game 7 days later, Active date is D0.",
                            "explainCn": "D7 活跃留存率 = 首次玩了游戏的活跃玩家在7天后返回游戏的比例，其中活跃日期为 D0。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "payer",
                            "metric_key": "paid_users",
                            "enName": "Payer",
                            "cnName": "付费人数",
                            "rainbowKey": "",
                            "explainEn": "Total number of users who have payment behaviors in the statistical period (vopenid deduplicated).",
                            "explainCn": "统计周期内产生流水行为的去重用户总数（vopenid数去重）。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "payer_ratio",
                            "metric_key": "payer_rate",
                            "enName": "Payer%",
                            "cnName": "付费渗透率",
                            "rainbowKey": "",
                            "explainEn": "Number of paying users/Number of active users during the statistical period.",
                            "explainCn": "付费渗透率=统计周期内消费用户数/活跃用户数。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "arpu",
                            "metric_key": "arpu",
                            "enName": "ARPU($)",
                            "cnName": "活跃ARPU($)",
                            "rainbowKey": "",
                            "explainEn": "Average Revenue Per Active Users.Consumption amount/Number of active users in the statistical period.",
                            "explainCn": "活跃ARPU($)=统计周期内消费额/活跃用户数。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "arppu",
                            "metric_key": "arppu",
                            "enName": "ARPPU($)",
                            "cnName": "付费ARPPU($)",
                            "rainbowKey": "",
                            "explainEn": "Average Revenue Per Paid Users.Consumption amount/Number of payers during the statistical period.",
                            "explainCn": "平均每付费用户收入。在统计期间内的消费金额/付费人数。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "newPayer",
                            "metric_key": "new_paid_users",
                            "enName": "First-time Payer",
                            "cnName": "首次付费用户",
                            "rainbowKey": "",
                            "explainEn": "The number of users who have payment behaviors for the first time in the statistical period.",
                            "explainCn": "在游戏内首次发生付费行为的玩家数",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "newRevenue",
                            "metric_key": "new_pay_amount",
                            "enName": "Revenue(first-time payer)",
                            "cnName": "首次付费用户金额",
                            "rainbowKey": "",
                            "explainEn": "Amount actually paid by first-time payer in the statistical period.",
                            "explainCn": "统计周期内的首次付费用户产生的所有付费金额。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "newArppu",
                            "metric_key": "new_arppu",
                            "enName": "First-time Payer ARPPU($)",
                            "cnName": "首次付费用户ARPPU($)",
                            "rainbowKey": "",
                            "explainEn": "Consumption amount of first-time payer/Number of first-time payer during the statistical period.",
                            "explainCn": "首次付费用户ARPPU($)=统计周期内首次付费用户的消费额/首次付费用户数。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "alc",
                            "metric_key": "alc",
                            "enName": "Sessions per user",
                            "cnName": "平均登录次数",
                            "rainbowKey": "",
                            "explainEn": "Sessions per user.\nDaily: Sum of the number of times all users have entered the game on that day/Players logged in the game on the day.\nWeekly: Sum of the number of times all users have entered the game on that week/Players logged in the game on the week.\nMonthly: Sum of the number of times all users have entered the game on that month/Players logged in the game on the month.",
                            "explainCn": "日：平均登录次数=当日所有用户进入游戏次数总和/当日活跃用户\n周：平均登录次数=当周所有用户进入游戏次数总和/当周活跃用户\n月：平均登录次数=当月所有用户进入游戏次数总和/当月活跃用户",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "retentionUsers",
                            "metric_key": "retention_users",
                            "enName": "DAU Retention Users",
                            "cnName": "日活留存",
                            "rainbowKey": "",
                            "explainEn": "The number of users who logged in during the recent 7 days(T-1~T-7) and have logged in to the game during the statistical period (deduplicated).",
                            "explainCn": "日活跃构成中的留存用户数，统计周期前一个周期 前7天(T-1~T-7) 登录了游戏并且在统计周期当期也有登录的用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "churnUsers",
                            "metric_key": "churn_users",
                            "enName": "Churn Users",
                            "cnName": "日流失",
                            "rainbowKey": "",
                            "explainEn": "Daily: The number of users who logged in yesterday but did not log in today.\nWeekly: The number of users who logged in last week but did not log in this week.\nMonthly: The number of users who logged in last month but did not log in this month.",
                            "explainCn": "日：昨天登录了并且在今天未登录的用户数\n周：上周登录了并且在本周未登录的用户数\n月：上个月登录了并且在本月未登录的用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "churnRate",
                            "metric_key": "churn_rate",
                            "enName": "Churn%",
                            "cnName": "流失率",
                            "rainbowKey": "",
                            "explainEn": "Daily: Churn Users / Active Users Yesterday.\nWeekly: Churn Users / Active Users Last Week.\nMonthly: Churn Users / Active Users Last Month.",
                            "explainCn": "日=日流失用户/昨日的活跃用户\n周=周流失用户/上周的活跃用户\n月=月流失用户/上月的活跃用户。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "returnUsers",
                            "metric_key": "return_users",
                            "enName": "DAU Return Users",
                            "cnName": "日回流",
                            "rainbowKey": "",
                            "explainEn": "Daily Return = Daily Active - Daily Retained - Daily New.\nWeekly Return = Weekly Active - Weekly Retained - Weekly New.\nMonthly Return = Monthly Active - Monthly Retained - Monthly New.",
                            "explainCn": "日回流=日活跃-日新进-日留存\n周回流=周活跃-周新进-周留存\n月回流=月活跃-月新进-月留存",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "wd237",
                            "metric_key": "weighted_d2",
                            "enName": "Weighted D2",
                            "cnName": "加权次留",
                            "rainbowKey": "",
                            "explainEn": "Day 2 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 2 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                            "explainCn": "加权次留=游戏上线之日起至统计日对（新注册用户数*新增次日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "weightedD3",
                            "metric_key": "weighted_d3",
                            "enName": "Weighted D3",
                            "cnName": "加权3留",
                            "rainbowKey": "",
                            "explainEn": "Day 3 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 3 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                            "explainCn": "加权3留=游戏上线之日起至统计日对（新注册用户数*新增3日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "weightedD7",
                            "metric_key": "weighted_d7",
                            "enName": "Weighted D7",
                            "cnName": "加权7留",
                            "rainbowKey": "",
                            "explainEn": "Day 7 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 7 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                            "explainCn": "加权7留=游戏上线之日起至统计日对（新注册用户数*新增7日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "weightedD14",
                            "metric_key": "weighted_d14",
                            "enName": "Weighted D14",
                            "cnName": "加权14留",
                            "rainbowKey": "",
                            "explainEn": "Day 14 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 14 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                            "explainCn": "加权14留=游戏上线之日起至统计日对（新注册用户数*新增14日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "firstLoginRatio",
                            "metric_key": "first_login_ratio",
                            "enName": "1st Order Login%",
                            "cnName": "一阶登录比",
                            "rainbowKey": "",
                            "explainEn": "1st Order Login%: 3-day valid registers / 2-day valid registers.\n2-day valid registers: the number of users who login for at least two days within seven days, starting from the day of registering.\n3-day valid registers: the number of users who login for at least three days within seven days, starting from the day of registering. Considered as the retention users of 2-day valid registers.",
                            "explainCn": "一阶登录比=3天有效注册用户数/2天有效注册用户数\n2天有效注册用户：从注册日开始计算，七天内至少有2天登录游戏的用户数\n3天有效注册用户：从注册日开始计算，七天内至少有3天登录游戏的用户数，认为是2天有效注册用户的留存用户；",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "secondLoginRatio",
                            "metric_key": "second_login_ratio",
                            "enName": "2nd Order Login%",
                            "cnName": "二阶登录比",
                            "rainbowKey": "",
                            "explainEn": "2nd Order Login%: 3-day valid retained users / 3-day valid registers.\n3-day valid registers: the number of users who login for at least three days within seven days, starting from the day of registering.\n3-day valid retained users: the number of 3-day valid registered users who login within the eighth day and the fourteenth day from the day of registering. Considered as the retention users of 3-day valid registers.",
                            "explainCn": "二阶登录比=3天有效注册留存用户数/3天有效注册用户数\n3天有效注册留存用户：3天有效注册用户数中，在8-14天有登录行为的用户数\n3天有效注册用户：从注册日开始计算，七天内至少有3天登录游戏的用户数",
                            "type": "percent",
                            "decimal": 2
                          }
                        ],
                        "Week": [
                          {
                            "value": "tru",
                            "metric_key": "total_users",
                            "enName": "TNU",
                            "cnName": "总注册用户数",
                            "rainbowKey": "",
                            "explainEn": "Total New Users. Total number of registered users accumulated to the statistical day (vopenid deduplicated).",
                            "explainCn": "累计至统计日的注册用户总数(vopenid数去重)。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "new",
                            "metric_key": "new_users",
                            "enName": "New",
                            "cnName": "新进用户",
                            "rainbowKey": "",
                            "explainEn": "New Register Users.Total number of newly-registered users in the statistical period (vopenid deduplicated).",
                            "explainCn": "统计周期内新注册用户数(vopenid数去重)。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "avgNewUsers",
                            "metric_key": "avg_new_users",
                            "enName": "Avg.Daily New",
                            "cnName": "平均每日新进用户数",
                            "rainbowKey": "",
                            "explainEn": "Average number of daily newly-registered users in the statistical period.",
                            "explainCn": "统计周期内平均每日新注册用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "wau",
                            "metric_key": "active_users",
                            "enName": "WAU",
                            "cnName": "周活跃",
                            "rainbowKey": "",
                            "explainEn": "Weekly Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).",
                            "explainCn": "统计周期内登录过游戏的用户数(vopenid数去重)。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "avg.wau",
                            "metric_key": "avg_active_users",
                            "enName": "Week Avg.DAU",
                            "cnName": "周平均活跃",
                            "rainbowKey": "",
                            "explainEn": "Average number of daily users who have logged in to the game during the statistical period.",
                            "explainCn": "统计周期内平均每日登录过游戏的用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "revenue",
                            "metric_key": "pay_amount",
                            "enName": "Revenue($)",
                            "cnName": "付费金额($)",
                            "rainbowKey": "",
                            "explainEn": "Total player payment amount in statistical period, which does not include refund data, used the exchange rate from last-month settlement. This amount will deviate from the actual settlement of accounts this month for about 5% to 30%, due to the difference in exchange rate, timezone, billing amount. Please take note.",
                            "explainCn": "统计周期内玩家的付费金额总额，注：此收入不含退款数据，且采用汇率为财务上一月结算汇率，与实际财务结算会在汇率、时区、计费金额等情况上会有误差，误差在5%-30%不等，请知悉。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "avgPayAmount",
                            "metric_key": "avg_pay_amount",
                            "enName": "Week Avg.Revenue($)",
                            "cnName": "周平均付费金额($)",
                            "rainbowKey": "",
                            "explainEn": "Count the average weekly amount actually paid by the current players in the statistical period.",
                            "explainCn": "统计周期内玩家平均每周的实际付费金额",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "pcu",
                            "metric_key": "pcu",
                            "enName": "PCU",
                            "cnName": "最高同时在线",
                            "rainbowKey": "",
                            "explainEn": "The highest number of users online simultaneously at each moment (every 5 minutes) of the day.",
                            "explainCn": "取当天各时刻（每5分钟打点）最高的同时在线用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "acu",
                            "metric_key": "acu",
                            "enName": "ACU",
                            "cnName": "平均同时在线",
                            "rainbowKey": "",
                            "explainEn": "The average number of users online simultaneously at each moment (every 5 minutes) of the day.",
                            "explainCn": "将当天内各时刻（每5分钟打点）的在线数进行平均统计",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "aot",
                            "metric_key": "aot",
                            "enName": "Avg.Playtime(min)",
                            "cnName": "平均在线时长(分钟)",
                            "rainbowKey": "",
                            "explainEn": "Daily: Daily Average Play Time.Total play time/Number of active users (min).\nWeekly: Weekly Average Play Time. Total play time/Weekly active users (min).\nMonthly: Monthly Average Play Time. Total play time/Monthly active users (min).",
                            "explainCn": "日平均在线时长=总在线时长/活跃用户数（单位：分钟\n周平均在线时长=周总在线时长/周活跃用户数（单位：分钟\n月平均在线时长=月总在线时长/月活跃用户数（单位：分钟）",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "saot",
                            "metric_key": "saot",
                            "enName": "Avg.Daily Playtime(min)",
                            "cnName": "周日平均在线时长(分钟)",
                            "rainbowKey": "",
                            "explainEn": "Avg.Daily Playtime(min)=Total play time/Sum of daily active users (min)",
                            "explainCn": "周日平均在线时长=周总在线时长/当周每日活跃人数之和",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "w23",
                            "metric_key": "w2",
                            "enName": "W2",
                            "cnName": "次周留存",
                            "rainbowKey": "",
                            "explainEn": "The retention rate of new register users on week 2. Number of retained users on week N from XX (registration date) / Number of new users on XX (registration week). Registration week is week 1.",
                            "explainCn": "次周留存=xx注册日期第2周存留用户数/xx注册周新注册用户数，注册周是第一周。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "w3",
                            "metric_key": "w3",
                            "enName": "W3",
                            "cnName": "3周留存",
                            "rainbowKey": "",
                            "explainEn": "The retention rate of new register users on week 3. Registration week is week 1.",
                            "explainCn": "3留=xx注册日期第3周存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "w4",
                            "metric_key": "w4",
                            "enName": "W4",
                            "cnName": "4周留存",
                            "rainbowKey": "",
                            "explainEn": "The retention rate of new register users on week 4. Registration week is week 1.",
                            "explainCn": "4周留存=xx注册日期第4周存留用户数/xx注册周新注册用户数，注册周是第一周。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "active_retention_w2",
                            "metric_key": "active_retention_w2",
                            "enName": "Active Retention W2",
                            "cnName": "活跃次周留存",
                            "rainbowKey": "",
                            "explainEn": "Active retention W2 = the percentage of players that played the game on this day and returned to the game 2 weeks later, Active date is W0.",
                            "explainCn": "W2 活跃留存率 = 首次玩了游戏的活跃玩家在2周后返回游戏的比例，其中活跃日期为 W0。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "active_retention_w3",
                            "metric_key": "active_retention_w3",
                            "enName": "Active Retention W3",
                            "cnName": "活跃3周留存",
                            "rainbowKey": "",
                            "explainEn": "Active retention W3 = the percentage of players that played the game on this day and returned to the game 3 weeks later, Active date is W0.",
                            "explainCn": "W3 活跃留存率 = 首次玩了游戏的活跃玩家在3周后返回游戏的比例，其中活跃日期为 W0。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "active_retention_w4",
                            "metric_key": "active_retention_w4",
                            "enName": "Active Retention W4",
                            "cnName": "活跃4周留存",
                            "rainbowKey": "",
                            "explainEn": "Active retention W4 = the percentage of players that played the game on this day and returned to the game 4 weeks later, Active date is W0.",
                            "explainCn": "W4 活跃留存率 = 首次玩了游戏的活跃玩家在4周后返回游戏的比例，其中活跃日期为 W0。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "payer",
                            "metric_key": "paid_users",
                            "enName": "Payer",
                            "cnName": "付费人数",
                            "rainbowKey": "",
                            "explainEn": "Total number of users who have payment behaviors in the statistical period (vopenid deduplicated).",
                            "explainCn": "统计周期内产生流水行为的去重用户总数（vopenid数去重）。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "payer_ratio",
                            "metric_key": "payer_rate",
                            "enName": "Payer%",
                            "cnName": "付费渗透率",
                            "rainbowKey": "",
                            "explainEn": "Number of paying users/Number of active users during the statistical period.",
                            "explainCn": "付费渗透率=统计周期内消费用户数/活跃用户数。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "arpu",
                            "metric_key": "arpu",
                            "enName": "ARPU($)",
                            "cnName": "活跃ARPU($)",
                            "rainbowKey": "",
                            "explainEn": "Average Revenue Per Active Users.Consumption amount/Number of active users in the statistical period.",
                            "explainCn": "活跃ARPU($)=统计周期内消费额/活跃用户数。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "arppu",
                            "metric_key": "arppu",
                            "enName": "ARPPU($)",
                            "cnName": "付费ARPPU($)",
                            "rainbowKey": "",
                            "explainEn": "Average Revenue Per Paid Users.Consumption amount/Number of payers during the statistical period.",
                            "explainCn": "平均每付费用户收入。在统计期间内的消费金额/付费人数。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "newPaidUsers",
                            "metric_key": "new_paid_users",
                            "enName": "First-time Payer",
                            "cnName": "首次付费用户",
                            "rainbowKey": "",
                            "explainEn": "The number of users who have payment behaviors for the first time in the statistical period.",
                            "explainCn": "在游戏内首次发生付费行为的玩家数",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "newPayAmount",
                            "metric_key": "new_pay_amount",
                            "enName": "Revenue(first-time payer)",
                            "cnName": "首次付费用户金额",
                            "rainbowKey": "",
                            "explainEn": "Amount actually paid by first-time payer in the statistical period.",
                            "explainCn": "统计周期内的首次付费用户产生的所有付费金额。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "newArppu",
                            "metric_key": "new_arppu",
                            "enName": "First-time Payer ARPPU($)",
                            "cnName": "首次付费用户ARPPU($)",
                            "rainbowKey": "",
                            "explainEn": "Consumption amount of first-time payer/Number of first-time payer during the statistical period.",
                            "explainCn": "首次付费用户ARPPU($)=统计周期内首次付费用户的消费额/首次付费用户数。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "alc",
                            "metric_key": "alc",
                            "enName": "Sessions per user",
                            "cnName": "平均登录次数",
                            "rainbowKey": "",
                            "explainEn": "Sessions per user.\nDaily: Sum of the number of times all users have entered the game on that day/Players logged in the game on the day.\nWeekly: Sum of the number of times all users have entered the game on that week/Players logged in the game on the week.\nMonthly: Sum of the number of times all users have entered the game on that month/Players logged in the game on the month.",
                            "explainCn": "日：平均登录次数=当日所有用户进入游戏次数总和/当日活跃用户\n周：平均登录次数=当周所有用户进入游戏次数总和/当周活跃用户\n月：平均登录次数=当月所有用户进入游戏次数总和/当月活跃用户",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "retentionUsers",
                            "metric_key": "retention_users",
                            "enName": "WAU Retention Users",
                            "cnName": "周活留存",
                            "rainbowKey": "",
                            "explainEn": "The number of users who logged in last week and have logged in to the game during the statistical period (deduplicated).",
                            "explainCn": "周活跃构成中的留存用户数，统计周期前一个周期（上周）登录了游戏并且在统计周期当期也有登录的用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "churnUsers",
                            "metric_key": "churn_users",
                            "enName": "Churn Users",
                            "cnName": "周流失",
                            "rainbowKey": "",
                            "explainEn": "Daily: The number of users who logged in yesterday but did not log in today.\nWeekly: The number of users who logged in last week but did not log in this week.\nMonthly: The number of users who logged in last month but did not log in this month.",
                            "explainCn": "日：昨天登录了并且在今天未登录的用户数\n周：上周登录了并且在本周未登录的用户数\n月：上个月登录了并且在本月未登录的用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "churnRate",
                            "metric_key": "churn_rate",
                            "enName": "Churn%",
                            "cnName": "流失率",
                            "rainbowKey": "",
                            "explainEn": "Daily: Churn Users / Active Users Yesterday.\nWeekly: Churn Users / Active Users Last Week.\nMonthly: Churn Users / Active Users Last Month.",
                            "explainCn": "日=日流失用户/昨日的活跃用户\n周=周流失用户/上周的活跃用户\n月=月流失用户/上月的活跃用户。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "returnUsers",
                            "metric_key": "return_users",
                            "enName": "WAU Return Users",
                            "cnName": "周回流",
                            "rainbowKey": "",
                            "explainEn": "Daily Return = Daily Active - Daily Retained - Daily New.\nWeekly Return = Weekly Active - Weekly Retained - Weekly New.\nMonthly Return = Monthly Active - Monthly Retained - Monthly New.",
                            "explainCn": "日回流=日活跃-日新进-日留存\n周回流=周活跃-周新进-周留存\n月回流=月活跃-月新进-月留存",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "weighted_w2",
                            "metric_key": "weighted_d2",
                            "enName": "Weighted W2",
                            "cnName": "加权次周留存",
                            "rainbowKey": "",
                            "explainEn": "Week 2 weighted retention ratio, which refers to the sum of (number of newly-registered users * week 2 retention ratio) from the game launching week to the statistical week/the sum of the number of newly-registered users from the game launching week to the statistical week.",
                            "explainCn": "加权次周留存=游戏上线之周起至统计周对（新注册用户数*新增次周留存率）求和/游戏上线之周起至统计周新注册用户数之和。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "weighted_w3",
                            "metric_key": "weighted_d3",
                            "enName": "Weighted W3",
                            "cnName": "加权3周留存",
                            "rainbowKey": "",
                            "explainEn": "Week 3 weighted retention ratio, which refers to the sum of (number of newly-registered users * week 3 retention ratio) from the game launching week to the statistical week/the sum of the number of newly-registered users from the game launching week to the statistical week.",
                            "explainCn": "加权3周留存=游戏上线之周起至统计周对（新注册用户数*新增3周留存率）求和/游戏上线之周起至统计周新注册用户数之和。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "weighted_w4",
                            "metric_key": "weighted_w4",
                            "enName": "Weighted W4",
                            "cnName": "加权4周留存",
                            "rainbowKey": "",
                            "explainEn": "Week 4 weighted retention ratio, which refers to the sum of (number of newly-registered users * week 4 retention ratio) from the game launching week to the statistical week/the sum of the number of newly-registered users from the game launching week to the statistical week.",
                            "explainCn": "加权4周留存=游戏上线之周起至统计周对（新注册用户数*新增4周留存率）求和/游戏上线之周起至统计周新注册用户数之和。"
                          }
                        ],
                        "Month": [
                          {
                            "value": "tru",
                            "metric_key": "total_users",
                            "enName": "TNU",
                            "cnName": "总注册用户数",
                            "rainbowKey": "",
                            "explainEn": "Total New Users. Total number of registered users accumulated to the statistical day (vopenid deduplicated).",
                            "explainCn": "累计至统计日的注册用户总数(vopenid数去重)。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "new",
                            "metric_key": "new_users",
                            "enName": "New",
                            "cnName": "新进用户",
                            "rainbowKey": "",
                            "explainEn": "New Register Users.Total number of newly-registered users in the statistical period (vopenid deduplicated).",
                            "explainCn": "统计周期内新注册用户数(vopenid数去重)。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "avgNewUsers",
                            "metric_key": "avg_new_users",
                            "enName": "Avg.Daily New",
                            "cnName": "平均每日新进用户数",
                            "rainbowKey": "",
                            "explainEn": "Average number of daily newly-registered users in the statistical period.",
                            "explainCn": "统计周期内平均每日新注册用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "mau",
                            "metric_key": "active_users",
                            "enName": "MAU",
                            "cnName": "月活跃",
                            "rainbowKey": "",
                            "explainEn": "Monthly Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).",
                            "explainCn": "统计周期内登录过游戏的用户数(vopenid数去重)。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "avg.mau",
                            "metric_key": "avg_active_users",
                            "enName": "Month Avg.DAU",
                            "cnName": "月平均活跃",
                            "rainbowKey": "",
                            "explainEn": "Average number of daily users who have logged in to the game during the statistical period.",
                            "explainCn": "统计周期内平均每日登录过游戏的用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "revenue",
                            "metric_key": "pay_amount",
                            "enName": "Revenue($)",
                            "cnName": "付费金额($)",
                            "rainbowKey": "",
                            "explainEn": "Total player payment amount in statistical period, which does not include refund data, used the exchange rate from last-month settlement. This amount will deviate from the actual settlement of accounts this month for about 5% to 30%, due to the difference in exchange rate, timezone, billing amount. Please take note.",
                            "explainCn": "统计周期内玩家的付费金额总额，注：此收入不含退款数据，且采用汇率为财务上一月结算汇率，与实际财务结算会在汇率、时区、计费金额等情况上会有误差，误差在5%-30%不等，请知悉。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "avgPayAmount",
                            "metric_key": "avg_pay_amount",
                            "enName": "Month Avg.Revenue($)",
                            "cnName": "月平均付费金额($)",
                            "rainbowKey": "",
                            "explainEn": "Count the average monthly amount actually paid by the current players in the statistical period.",
                            "explainCn": "统计周期内玩家平均每月的实际付费金额总额",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "pcu",
                            "metric_key": "pcu",
                            "enName": "PCU",
                            "cnName": "最高同时在线",
                            "rainbowKey": "",
                            "explainEn": "The highest number of users online simultaneously at each moment (every 5 minutes) of the day.",
                            "explainCn": "取当天各时刻（每5分钟打点）最高的同时在线用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "acu",
                            "metric_key": "acu",
                            "enName": "ACU",
                            "cnName": "平均同时在线",
                            "rainbowKey": "",
                            "explainEn": "The average number of users online simultaneously at each moment (every 5 minutes) of the day.",
                            "explainCn": "将当天内各时刻（每5分钟打点）的在线数进行平均统计",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "aot",
                            "metric_key": "aot",
                            "enName": "Avg.Playtime(min)",
                            "cnName": "平均在线时长(分钟)",
                            "rainbowKey": "",
                            "explainEn": "Daily: Daily Average Play Time.Total play time/Number of active users (min).\nWeekly: Weekly Average Play Time. Total play time/Weekly active users (min).\nMonthly: Monthly Average Play Time. Total play time/Monthly active users (min).",
                            "explainCn": "日平均在线时长=总在线时长/活跃用户数（单位：分钟\n周平均在线时长=周总在线时长/周活跃用户数（单位：分钟\n月平均在线时长=月总在线时长/月活跃用户数（单位：分钟）",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "m23",
                            "metric_key": "m2",
                            "enName": "M2",
                            "cnName": "次月留存",
                            "rainbowKey": "",
                            "explainEn": "The retention rate of new register users on month 2. Number of retained users on month N from XX (registration date) / Number of new users on XX (registration month). Registration month is month 1.",
                            "explainCn": "次月留存=xx注册日期第2月存留用户数/xx注册月新注册用户数，注册月是第一月。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "m3",
                            "metric_key": "m3",
                            "enName": "M3",
                            "cnName": "3月留存",
                            "rainbowKey": "",
                            "explainEn": "The retention rate of new register users on month 3. Registration month is month 1.",
                            "explainCn": "3月留存=xx注册日期第3月存留用户数/xx注册月新注册用户数，注册月是第一月。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "m4",
                            "metric_key": "m4",
                            "enName": "M4",
                            "cnName": "4月留存",
                            "rainbowKey": "",
                            "explainEn": "The retention rate of new register users on month 4. Registration month is month 1.",
                            "explainCn": "4月留存=xx注册日期第4月存留用户数/xx注册月新注册用户数，注册月是第一月。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "active_retention_m2",
                            "metric_key": "active_retention_m2",
                            "enName": "Active Retention M2",
                            "cnName": "活跃次月留存",
                            "rainbowKey": "",
                            "explainEn": "Active retention M2 = the percentage of players that played the game on this day and returned to the game 2 months later, Active date is M0.",
                            "explainCn": "M2 活跃留存率 = 首次玩了游戏的活跃玩家在2月后返回游戏的比例，其中活跃日期为 M0。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "active_retention_m3",
                            "metric_key": "active_retention_m3",
                            "enName": "Active Retention M3",
                            "cnName": "活跃3月留存",
                            "rainbowKey": "",
                            "explainEn": "Active retention M3 = the percentage of players that played the game on this day and returned to the game 3 months later, Active date is M0.",
                            "explainCn": "M3 活跃留存率 = 首次玩了游戏的活跃玩家在3月后返回游戏的比例，其中活跃日期为 M0。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "active_retention_m4",
                            "metric_key": "active_retention_m4",
                            "enName": "Active Retention M4",
                            "cnName": "活跃4月留存",
                            "rainbowKey": "",
                            "explainEn": "	Active retention M4 = the percentage of players that played the game on this day and returned to the game 4 months later, Active date is M0.",
                            "explainCn": "M4 活跃留存率 = 首次玩了游戏的活跃玩家在4月后返回游戏的比例，其中活跃日期为 M0。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "payer",
                            "metric_key": "paid_users",
                            "enName": "Payer",
                            "cnName": "付费人数",
                            "rainbowKey": "",
                            "explainEn": "Total number of users who have payment behaviors in the statistical period (vopenid deduplicated).",
                            "explainCn": "统计周期内产生流水行为的去重用户总数（vopenid数去重）。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "payer_ratio",
                            "metric_key": "payer_rate",
                            "enName": "Payer%",
                            "cnName": "付费渗透率",
                            "rainbowKey": "",
                            "explainEn": "Number of paying users/Number of active users during the statistical period.",
                            "explainCn": "付费渗透率=统计周期内消费用户数/活跃用户数。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "arpu",
                            "metric_key": "arpu",
                            "enName": "ARPU($)",
                            "cnName": "活跃ARPU($)",
                            "rainbowKey": "",
                            "explainEn": "Average Revenue Per Active Users.Consumption amount/Number of active users in the statistical period.",
                            "explainCn": "活跃ARPU($)=统计周期内消费额/活跃用户数。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "arppu",
                            "metric_key": "arppu",
                            "enName": "ARPPU($)",
                            "cnName": "付费ARPPU($)",
                            "rainbowKey": "",
                            "explainEn": "Average Revenue Per Paid Users.Consumption amount/Number of payers during the statistical period.",
                            "explainCn": "平均每付费用户收入。在统计期间内的消费金额/付费人数。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "newPaidUsers",
                            "metric_key": "new_paid_users",
                            "enName": "First-time Payer",
                            "cnName": "首次付费用户",
                            "rainbowKey": "",
                            "explainEn": "The number of users who have payment behaviors for the first time in the statistical period.",
                            "explainCn": "在游戏内首次发生付费行为的玩家数",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "newPayAmount",
                            "metric_key": "new_pay_amount",
                            "enName": "Revenue(first-time payer)",
                            "cnName": "首次付费用户金额",
                            "rainbowKey": "",
                            "explainEn": "Amount actually paid by first-time payer in the statistical period.",
                            "explainCn": "统计周期内的首次付费用户产生的所有付费金额。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "newArppu",
                            "metric_key": "new_arppu",
                            "enName": "First-time Payer ARPPU($)",
                            "cnName": "首次付费用户ARPPU($)",
                            "rainbowKey": "",
                            "explainEn": "Consumption amount of first-time payer/Number of first-time payer during the statistical period.",
                            "explainCn": "首次付费用户ARPPU($)=统计周期内首次付费用户的消费额/首次付费用户数。",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "alc",
                            "metric_key": "alc",
                            "enName": "Sessions per user",
                            "cnName": "平均登录次数",
                            "rainbowKey": "",
                            "explainEn": "Sessions per user.\nDaily: Sum of the number of times all users have entered the game on that day/Players logged in the game on the day.\nWeekly: Sum of the number of times all users have entered the game on that week/Players logged in the game on the week.\nMonthly: Sum of the number of times all users have entered the game on that month/Players logged in the game on the month.",
                            "explainCn": "日：平均登录次数=当日所有用户进入游戏次数总和/当日活跃用户\n周：平均登录次数=当周所有用户进入游戏次数总和/当周活跃用户\n月：平均登录次数=当月所有用户进入游戏次数总和/当月活跃用户",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "retentionUsers",
                            "metric_key": "retention_users",
                            "enName": "MAU Retention Users",
                            "cnName": "月活留存",
                            "rainbowKey": "",
                            "explainEn": "The number of users who logged in last month and have logged in to the game during the statistical period (deduplicated).",
                            "explainCn": "月活跃构成中的留存用户数，统计周期前一个周期（上月）登录了游戏并且在统计周期当期也有登录的用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "churnUsers",
                            "metric_key": "churn_users",
                            "enName": "Churn Users",
                            "cnName": "月流失",
                            "rainbowKey": "",
                            "explainEn": "Daily: The number of users who logged in yesterday but did not log in today.\nWeekly: The number of users who logged in last week but did not log in this week.\nMonthly: The number of users who logged in last month but did not log in this month.",
                            "explainCn": "日：昨天登录了并且在今天未登录的用户数\n周：上周登录了并且在本周未登录的用户数\n月：上个月登录了并且在本月未登录的用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "churnRate",
                            "metric_key": "churn_rate",
                            "enName": "Churn%",
                            "cnName": "流失率",
                            "rainbowKey": "",
                            "explainEn": "Daily: Churn Users / Active Users Yesterday.\nWeekly: Churn Users / Active Users Last Week.\nMonthly: Churn Users / Active Users Last Month.",
                            "explainCn": "日=日流失用户/昨日的活跃用户\n周=周流失用户/上周的活跃用户\n月=月流失用户/上月的活跃用户。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "returnUsers",
                            "metric_key": "return_users",
                            "enName": "MAU Return Users",
                            "cnName": "月回流",
                            "rainbowKey": "",
                            "explainEn": "Daily Return = Daily Active - Daily Retained - Daily New.\nWeekly Return = Weekly Active - Weekly Retained - Weekly New.\nMonthly Return = Monthly Active - Monthly Retained - Monthly New.",
                            "explainCn": "日回流=日活跃-日新进-日留存\n周回流=周活跃-周新进-周留存\n月回流=月活跃-月新进-月留存",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "weighted_m2",
                            "metric_key": "weighted_m2",
                            "enName": "Weighted M2",
                            "cnName": "加权次月留存",
                            "rainbowKey": "",
                            "explainEn": "Month 2 weighted retention ratio, which refers to the sum of (number of newly-registered users * month 2 retention ratio) from the game launching month to the statistical month/the sum of the number of newly-registered users from the game launching month to the statistical month.",
                            "explainCn": "加权次月留存=游戏上线之月起至统计月对（新注册用户数*新增次月留存率）求和/游戏上线之月起至统计月新注册用户数之和。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "weighted_m3",
                            "metric_key": "weighted_m3",
                            "enName": "Weighted M3",
                            "cnName": "加权3月留存",
                            "rainbowKey": "",
                            "explainEn": "Month 3 weighted retention ratio, which refers to the sum of (number of newly-registered users * month 3 retention ratio) from the game launching month to the statistical month/the sum of the number of newly-registered users from the game launching month to the statistical month.",
                            "explainCn": "加权3月留存=游戏上线之月起至统计月对（新注册用户数*新增3月留存率）求和/游戏上线之月起至统计月新注册用户数之和。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "weighted_m4",
                            "metric_key": "weighted_m4",
                            "enName": "Weighted M4",
                            "cnName": "加权4月留存",
                            "rainbowKey": "",
                            "explainEn": "Month 4 weighted retention ratio, which refers to the sum of (number of newly-registered users * month 4 retention ratio) from the game launching month to the statistical month/the sum of the number of newly-registered users from the game launching month to the statistical month.",
                            "explainCn": "加权4月留存=游戏上线之月起至统计月对（新注册用户数*新增4月留存率）求和/游戏上线之月起至统计月新注册用户数之和。"
                          }
                        ]
                      }
                    }
                  },
                  "children": [
                    {
                      "name": "DateComparisonMetricsTrend",
                      "props": {
                        "config": {
                          "subTitleCom": [
                            {
                              "titleEn": "Statistics Date",
                              "titleCn": "统计日期",
                              "subTitle1En": "Average",
                              "subTitle1Cn": "平均值 ",
                              "subTitle2En": "Sum ",
                              "subTitle2Cn": "汇总值",
                              "subTitle3En": "Max",
                              "subTitle3Cn": "最大值"
                            },
                            {
                              "titleEn": "Contrast Date",
                              "titleCn": "对比日期",
                              "subTitle1En": "Average",
                              "subTitle1Cn": "平均值",
                              "subTitle2En": "Sum ",
                              "subTitle2Cn": "汇总值",
                              "subTitle3En": "Max",
                              "subTitle3Cn": "最大值"
                            }
                          ]
                        }
                      }
                    }
                  ]
                }
              ]
            },
            {
              "name": "ComparisonTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/comparison_analysis/date/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/comparison_analysis/date/overall_performance/download"
                  },
                  "dataKey": "date_comparison",
                  "componentMetrics": [
                    {
                      "Day": [
                        {
                          "metricKey": "total_users",
                          "reqMetricKey": "total_users",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "TNU",
                          "cnName": "总注册用户数",
                          "explainEn": "Total New Users. Total number of registered users accumulated to the statistical day (vopenid deduplicated).",
                          "explainCn": "累计至统计日的注册用户总数(vopenid数去重)。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_users",
                          "reqMetricKey": "new_users",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "New",
                          "cnName": "新进用户",
                          "explainEn": "New Register Users.Total number of newly-registered users in the statistical period (vopenid deduplicated).",
                          "explainCn": "统计周期内新注册用户数(vopenid数去重)。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "active_users",
                          "reqMetricKey": "active_users",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "DAU",
                          "cnName": "日活跃",
                          "explainEn": "Daily Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).",
                          "explainCn": "统计周期内登录过游戏的用户数(vopenid数去重)。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "pay_amount",
                          "reqMetricKey": "pay_amount",
                          "enPercentWidth": 210,
                          "cnPercentWidth": 210,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 210,
                          "cnContrastWidth": 210,
                          "enName": "Revenue($)",
                          "cnName": "付费金额($)",
                          "explainEn": "Total player payment amount in statistical period, which does not include refund data, used the exchange rate from last-month settlement. This amount will deviate from the actual settlement of accounts this month for about 5% to 30%, due to the difference in exchange rate, timezone, billing amount. Please take note.",
                          "explainCn": "统计周期内玩家的付费金额总额，注：此收入不含退款数据，且采用汇率为财务上一月结算汇率，与实际财务结算会在汇率、时区、计费金额等情况上会有误差，误差在5%-30%不等，请知悉。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "pcu",
                          "reqMetricKey": "pcu",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "PCU",
                          "cnName": "最高同时在线",
                          "explainEn": "The highest number of users online simultaneously at each moment (every 5 minutes) of the day.",
                          "explainCn": "取当天各时刻（每5分钟打点）最高的同时在线用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "acu",
                          "reqMetricKey": "acu",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "ACU",
                          "cnName": "平均同时在线",
                          "explainEn": "The average number of users online simultaneously at each moment (every 5 minutes) of the day.",
                          "explainCn": "将当天内各时刻（每5分钟打点）的在线数进行平均统计。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "aot",
                          "reqMetricKey": "aot",
                          "enPercentWidth": 240,
                          "cnPercentWidth": 220,
                          "enWidth": 164,
                          "cnWidth": 190,
                          "enContrastWidth": 240,
                          "cnContrastWidth": 220,
                          "enName": "Avg.Playtime(min)",
                          "cnName": "平均在线时长(分钟)",
                          "explainEn": "Daily: Daily Average Play Time.Total play time/Number of active users (min).\nWeekly: Weekly Average Play Time. Total play time/Weekly active users (min).\nMonthly: Monthly Average Play Time. Total play time/Monthly active users (min).",
                          "explainCn": "日平均在线时长=总在线时长/活跃用户数（单位：分钟\n周平均在线时长=周总在线时长/周活跃用户数（单位：分钟\n月平均在线时长=月总在线时长/月活跃用户数（单位：分钟）",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d2",
                          "reqMetricKey": "d2",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 90,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D2",
                          "cnName": "次留",
                          "explainEn": "The retention rate of new register users on day 2. Number of retained users on day N from XX (registration date) / Number of new users on XX (registration date). Registration date is day 1.",
                          "explainCn": "次留=xx注册日期第2天存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d3",
                          "reqMetricKey": "d3",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 90,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D3",
                          "cnName": "3留",
                          "explainEn": "The retention rate of new register users on day 3. Registration date is day 1.",
                          "explainCn": "3留=xx注册日期第3天存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d4",
                          "reqMetricKey": "d4",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 90,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D4",
                          "cnName": "4留",
                          "explainEn": "The retention rate of new register users on day 4.Registration date is day 1.",
                          "explainCn": "4留=xx注册日期第4天存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d5",
                          "reqMetricKey": "d5",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 90,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D5",
                          "cnName": "5留",
                          "explainEn": "The retention rate of new register users on day 5.Registration date is day 1.",
                          "explainCn": "5留=xx注册日期第5天存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d6",
                          "reqMetricKey": "d6",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 90,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D6",
                          "cnName": "6留",
                          "explainEn": "The retention rate of new register users on day 6. Registration date is day 1.",
                          "explainCn": "6留=xx注册日期第6天存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d7",
                          "reqMetricKey": "d7",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 90,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D7",
                          "cnName": "7留",
                          "explainEn": "The retention rate of new register users on day 7.",
                          "explainCn": "7留=xx注册日期第7天存留用户数/xx注册日期新注册用户数，注册日期是第一天。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "active_retention_d2",
                          "reqMetricKey": "active_retention_d2",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 260,
                          "enWidth": 200,
                          "cnWidth": 140,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 180,
                          "enName": "Active Retention D2",
                          "cnName": "活跃次留",
                          "explainEn": "Active retention D2 = the percentage of players that played the game on this day and returned to the game 2 days later, Active date is D0.",
                          "explainCn": "D2 活跃留存率 = 首次玩了游戏的活跃玩家在2天后返回游戏的比例，其中活跃日期为 D0。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "active_retention_d3",
                          "reqMetricKey": "active_retention_d3",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 260,
                          "enWidth": 200,
                          "cnWidth": 140,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 180,
                          "enName": "Active Retention D3",
                          "cnName": "活跃3留",
                          "explainEn": "Active retention D3 = the percentage of players that played the game on this day and returned to the game 3 days later, Active date is D0.",
                          "explainCn": "D3 活跃留存率 = 首次玩了游戏的活跃玩家在3天后返回游戏的比例，其中活跃日期为 D0。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "active_retention_d7",
                          "reqMetricKey": "active_retention_d7",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 260,
                          "enWidth": 200,
                          "cnWidth": 140,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 180,
                          "enName": "Active Retention D7",
                          "cnName": "活跃7留",
                          "explainEn": "Active retention D7 = the percentage of players that played the game on this day and returned to the game 7 days later, Active date is D0.",
                          "explainCn": "D7 活跃留存率 = 首次玩了游戏的活跃玩家在7天后返回游戏的比例，其中活跃日期为 D0。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "paid_users",
                          "reqMetricKey": "paid_users",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 100,
                          "cnWidth": 100,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "Payer",
                          "cnName": "付费人数",
                          "explainEn": "Total number of users who have payment behaviors in the statistical period (vopenid deduplicated).",
                          "explainCn": "统计周期内产生流水行为的去重用户总数（vopenid数去重）。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "payer_rate",
                          "reqMetricKey": "payer_rate",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 76,
                          "cnWidth": 96,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "Payer%",
                          "cnName": "付费渗透率",
                          "explainEn": "Number of paying users/Number of active users during the statistical period.",
                          "explainCn": "付费渗透率=统计周期内消费用户数/活跃用户数。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "arpu",
                          "reqMetricKey": "arpu",
                          "enPercentWidth": 170,
                          "cnPercentWidth": 170,
                          "enWidth": 96,
                          "cnWidth": 126,
                          "enContrastWidth": 170,
                          "cnContrastWidth": 170,
                          "enName": "ARPU($)",
                          "cnName": "活跃ARPU($)",
                          "explainEn": "Average Revenue Per Active Users.Consumption amount/Number of active users in the statistical period.",
                          "explainCn": "活跃ARPU($)=统计周期内消费额/活跃用户数。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "arppu",
                          "reqMetricKey": "arppu",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 106,
                          "cnWidth": 170,
                          "enContrastWidth": 180,
                          "cnContrastWidth": 180,
                          "enName": "ARPPU($)",
                          "cnName": "付费ARPPU($)",
                          "explainEn": "Average Revenue Per Paid Users.Consumption amount/Number of payers during the statistical period.",
                          "explainCn": "平均每付费用户收入。在统计期间内的消费金额/付费人数。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_paid_users",
                          "reqMetricKey": "new_paid_users",
                          "enPercentWidth": 240,
                          "cnPercentWidth": 200,
                          "enWidth": 144,
                          "cnWidth": 126,
                          "enContrastWidth": 240,
                          "cnContrastWidth": 200,
                          "enName": "First-time Payer",
                          "cnName": "首次付费用户",
                          "explainEn": "The number of users who have payment behaviors for the first time in the statistical period.",
                          "explainCn": "在游戏内首次发生付费行为的玩家数",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_pay_amount",
                          "reqMetricKey": "new_pay_amount",
                          "enPercentWidth": 300,
                          "cnPercentWidth": 180,
                          "enWidth": 220,
                          "cnWidth": 165,
                          "enContrastWidth": 300,
                          "cnContrastWidth": 180,
                          "enName": "Revenue(first-time payer)",
                          "cnName": "首次付费用户金额",
                          "explainEn": "Amount actually paid by first-time payer in the statistical period.",
                          "explainCn": "统计周期内的首次付费用户产生的所有付费金额。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_arppu",
                          "reqMetricKey": "new_arppu",
                          "enPercentWidth": 310,
                          "cnPercentWidth": 240,
                          "enWidth": 240,
                          "cnWidth": 200,
                          "enContrastWidth": 310,
                          "cnContrastWidth": 240,
                          "enName": "First-time Payer ARPPU($)",
                          "cnName": "首次付费用户ARPPU($)",
                          "explainEn": "Consumption amount of first-time payer/Number of first-time payer during the statistical period.",
                          "explainCn": "首次付费用户ARPPU($)=统计周期内首次付费用户的消费额/首次付费用户数。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "alc",
                          "reqMetricKey": "alc",
                          "enPercentWidth": 230,
                          "cnPercentWidth": 150,
                          "enWidth": 160,
                          "cnWidth": 140,
                          "enContrastWidth": 230,
                          "cnContrastWidth": 150,
                          "enName": "Sessions per user",
                          "cnName": "平均登录次数",
                          "explainEn": "Sessions per user.\nDaily：Sum of the number of times all users have entered the game on that day/Players logged in the game on the day.\nWeekly：Sum of the number of times all users have entered the game on that week/Players logged in the game on the week.\nMonthly: Sum of the number of times all users have entered the game on that month/Players logged in the game on the month.",
                          "explainCn": "日：平均登录次数=当日所有用户进入游戏次数总和/当日活跃用户。\n周：平均登录次数=当周所有用户进入游戏次数总和/当周活跃用户。\n月：平均登录次数=当月所有用户进入游戏次数总和/当月活跃用户",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "retention_users",
                          "reqMetricKey": "retention_users",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 140,
                          "enWidth": 210,
                          "cnWidth": 171,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 140,
                          "enName": "DAU Retention Users",
                          "cnName": "日活留存",
                          "explainEn": "The number of users who logged in during the recent 7 days(T-1~T-7) and have logged in to the game during the statistical period (deduplicated).",
                          "explainCn": "日活跃构成中的留存用户数，统计周期前一个周期 前7天(T-1~T-7) 登录了游戏并且在统计周期当期也有登录的用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "churn_users",
                          "reqMetricKey": "churn_users",
                          "enPercentWidth": 190,
                          "cnPercentWidth": 140,
                          "enWidth": 114,
                          "cnWidth": 95,
                          "enContrastWidth": 190,
                          "cnContrastWidth": 140,
                          "enName": "Churn Users",
                          "cnName": "日流失",
                          "explainEn": "Daily: The number of users who logged in yesterday but did not log in today.\nWeekly: The number of users who logged in last week but did not log in this week.\nMonthly: The number of users who logged in last month but did not log in this month.",
                          "explainCn": "日：昨天登录了并且在今天未登录的用户数\n周：上周登录了并且在本周未登录的用户数n月：上个月登录了并且在本月未登录的用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "churn_rate",
                          "reqMetricKey": "churn_rate",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 80,
                          "cnWidth": 95,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "Churn%",
                          "cnName": "流失率",
                          "explainEn": "Daily: Churn Users / Active Users Yesterday.\nWeekly: Churn Users / Active Users Last Week.\nMonthly: Churn Users / Active Users Last Month.",
                          "explainCn": "日=日流失用户/昨日的活跃用户\n周=周流失用户/上周的活跃用户\n月=月流失用户/上月的活跃用户。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "return_users",
                          "reqMetricKey": "return_users",
                          "enPercentWidth": 250,
                          "cnPercentWidth": 140,
                          "enWidth": 170,
                          "cnWidth": 95,
                          "enContrastWidth": 250,
                          "cnContrastWidth": 140,
                          "enName": "DAU Return Users",
                          "cnName": "日回流",
                          "explainEn": "Daily Return = Daily Active - Daily Retained - Daily New.\nWeekly Return = Weekly Active - Weekly Retained - Weekly New.\nMonthly Return = Monthly Active - Monthly Retained - Monthly New.",
                          "explainCn": "日回流=日活跃-日新进-日留存\n周回流=周活跃-周新进-周留存\n月回流=月活跃-月新进-月留存。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_d2",
                          "reqMetricKey": "weighted_d2",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 122,
                          "cnWidth": 80,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted D2",
                          "cnName": "加权次留",
                          "explainEn": "Day 2 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 2 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                          "explainCn": "加权次留=游戏上线之日起至统计日对（新注册用户数*新增次日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "weighted_d3",
                          "reqMetricKey": "weighted_d3",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 122,
                          "cnWidth": 80,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted D3",
                          "cnName": "加权3留",
                          "explainEn": "Day 3 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 3 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                          "explainCn": "加权3留=游戏上线之日起至统计日对（新注册用户数*新增3日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_d7",
                          "reqMetricKey": "weighted_d7",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 122,
                          "cnWidth": 80,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted D7",
                          "cnName": "加权7留",
                          "explainEn": "Day 7 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 7 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                          "explainCn": "加权7留=游戏上线之日起至统计日对（新注册用户数*新增7日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_d14",
                          "reqMetricKey": "weighted_d14",
                          "enPercentWidth": 210,
                          "cnPercentWidth": 210,
                          "enWidth": 132,
                          "cnWidth": 90,
                          "enContrastWidth": 210,
                          "cnContrastWidth": 210,
                          "enName": "Weighted D14",
                          "cnName": "加权14留",
                          "explainEn": "Day 14 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 14 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                          "explainCn": "加权14留=游戏上线之日起至统计日对（新注册用户数*新增14日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "first_login_ratio",
                          "reqMetricKey": "first_login_ratio",
                          "enPercentWidth": 236,
                          "cnPercentWidth": 160,
                          "enWidth": 160,
                          "cnWidth": 145,
                          "enContrastWidth": 236,
                          "cnContrastWidth": 160,
                          "enName": "1st Order Login%",
                          "cnName": "一阶登录比",
                          "explainEn": "1st Order Login%: 3-day valid registers / 2-day valid registers.\n2-day valid registers: the number of users who login for at least two days within seven days, starting from the day of registering.\n3-day valid registers: the number of users who login for at least three days within seven days, starting from the day of registering. Considered as the retention users of 2-day valid registers.",
                          "explainCn": "一阶登录比=3天有效注册用户数/2天有效注册用户数\n2天有效注册用户：从注册日开始计算，七天内至少有2天登录游戏的用户数\n3天有效注册用户：从注册日开始计算，七天内至少有3天登录游戏的用户数，认为是2天有效注册用户的留存用户；",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "second_login_ratio",
                          "reqMetricKey": "second_login_ratio",
                          "enPercentWidth": 250,
                          "cnPercentWidth": 250,
                          "enWidth": 160,
                          "cnWidth": 145,
                          "enContrastWidth": 250,
                          "cnContrastWidth": 160,
                          "enName": "2nd Order Login%",
                          "cnName": "二阶登录比",
                          "explainEn": "2nd Order Login%: 3-day valid retained users / 3-day valid registers.\n3-day valid registers: the number of users who login for at least three days within seven days, starting from the day of registering.\n3-day valid retained users: the number of 3-day valid registered users who login within the eighth day and the fourteenth day from the day of registering. Considered as the retention users of 3-day valid registers.",
                          "explainCn": "二阶登录比=3天有效注册留存用户数/3天有效注册用户数\n3天有效注册留存用户：3天有效注册用户数中，在8-14天有登录行为的用户数\n3天有效注册用户：从注册日开始计算，七天内至少有3天登录游戏的用户数",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        }
                      ]
                    },
                    {
                      "Week": [
                        {
                          "metricKey": "total_users",
                          "reqMetricKey": "total_users",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "TNU",
                          "cnName": "总注册用户数",
                          "explainEn": "Total New Users. Total number of registered users accumulated to the statistical day (vopenid deduplicated).",
                          "explainCn": "累计至统计日的注册用户总数(vopenid数去重)。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_users",
                          "reqMetricKey": "new_users",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "New",
                          "cnName": "新进用户",
                          "explainEn": "New Register Users.Total number of newly-registered users in the statistical period (vopenid deduplicated).",
                          "explainCn": "统计周期内新注册用户数(vopenid数去重)。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "avg_new_users",
                          "reqMetricKey": "avg_new_users",
                          "enPercentWidth": 210,
                          "cnPercentWidth": 210,
                          "enWidth": 136,
                          "cnWidth": 160,
                          "enContrastWidth": 210,
                          "cnContrastWidth": 210,
                          "enName": "Avg.Daily New",
                          "cnName": "平均每日新进用户",
                          "explainEn": "Average number of daily newly-registered users in the statistical period.",
                          "explainCn": "统计周期内平均每日新注册用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "active_users",
                          "reqMetricKey": "active_users",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "WAU",
                          "cnName": "周活跃",
                          "explainEn": "Weekly Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).",
                          "explainCn": "统计周期内登录过游戏的用户数(vopenid数去重)。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "avg_active_users",
                          "reqMetricKey": "avg_active_users",
                          "enPercentWidth": 220,
                          "cnPercentWidth": 200,
                          "enWidth": 150,
                          "cnWidth": 120,
                          "enContrastWidth": 220,
                          "cnContrastWidth": 200,
                          "enName": "Week Avg.DAU",
                          "cnName": "周平均日活跃",
                          "explainEn": "Average number of daily users who have logged in to the game during the statistical period.",
                          "explainCn": "统计周期内平均每日登录过游戏的用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "pay_amount",
                          "reqMetricKey": "pay_amount",
                          "enPercentWidth": 210,
                          "cnPercentWidth": 210,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 210,
                          "cnContrastWidth": 210,
                          "enName": "Revenue($)",
                          "cnName": "付费金额($)",
                          "explainEn": "Total player payment amount in statistical period, which does not include refund data, used the exchange rate from last-month settlement. This amount will deviate from the actual settlement of accounts this month for about 5% to 30%, due to the difference in exchange rate, timezone, billing amount. Please take note.",
                          "explainCn": "统计周期内玩家的付费金额总额，注：此收入不含退款数据，且采用汇率为财务上一月结算汇率，与实际财务结算会在汇率、时区、计费金额等情况上会有误差，误差在5%-30%不等，请知悉。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "avg_pay_amount",
                          "reqMetricKey": "avg_pay_amount",
                          "enPercentWidth": 280,
                          "cnPercentWidth": 210,
                          "enWidth": 210,
                          "cnWidth": 150,
                          "enContrastWidth": 280,
                          "cnContrastWidth": 210,
                          "enName": "Week Avg.Revenue($)",
                          "cnName": "周平均付费金额($)",
                          "explainEn": "Count the average weekly amount actually paid by the current players in the statistical period.",
                          "explainCn": "统计周期内玩家平均每周的实际付费金额",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "pcu",
                          "reqMetricKey": "pcu",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "PCU",
                          "cnName": "最高同时在线",
                          "explainEn": "The highest number of users online simultaneously at each moment (every 5 minutes) of the day.",
                          "explainCn": "取当天各时刻（每5分钟打点）最高的同时在线用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "acu",
                          "reqMetricKey": "acu",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "ACU",
                          "cnName": "平均同时在线",
                          "explainEn": "The average number of users online simultaneously at each moment (every 5 minutes) of the day.",
                          "explainCn": "将当天内各时刻（每5分钟打点）的在线数进行平均统计。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "aot",
                          "reqMetricKey": "aot",
                          "enPercentWidth": 240,
                          "cnPercentWidth": 220,
                          "enWidth": 164,
                          "cnWidth": 190,
                          "enContrastWidth": 240,
                          "cnContrastWidth": 220,
                          "enName": "Avg.Playtime(min)",
                          "cnName": "平均在线时长(分钟)",
                          "explainEn": "Daily: Daily Average Play Time.Total play time/Number of active users (min).\nWeekly: Weekly Average Play Time. Total play time/Weekly active users (min).\nMonthly: Monthly Average Play Time. Total play time/Monthly active users (min).",
                          "explainCn": "日平均在线时长=总在线时长/活跃用户数（单位：分钟\n周平均在线时长=周总在线时长/周活跃用户数（单位：分钟\n月平均在线时长=月总在线时长/月活跃用户数（单位：分钟）",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "saot",
                          "reqMetricKey": "saot",
                          "enPercentWidth": 290,
                          "cnPercentWidth": 230,
                          "enWidth": 220,
                          "cnWidth": 190,
                          "enContrastWidth": 290,
                          "cnContrastWidth": 230,
                          "enName": "Avg.Daily Playtime(min)",
                          "cnName": "周日平均在线时长(分钟)",
                          "explainEn": "Avg.Daily Playtime(min)=Total play time/Sum of daily active users (min)",
                          "explainCn": "周日平均在线时长=周总在线时长/当周每日活跃人数之和",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "w2",
                          "reqMetricKey": "w2",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 90,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "W2",
                          "cnName": "次周留存",
                          "explainEn": "The retention rate of new register users on week 2. Number of retained users on week N from XX (registration date) / Number of new users on XX (registration week). Registration week is week 1.",
                          "explainCn": "次周留存=xx注册日期第2周存留用户数/xx注册周新注册用户数，注册周是第一周。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "w3",
                          "reqMetricKey": "w3",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 90,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "W3",
                          "cnName": "3周留存",
                          "explainEn": "The retention rate of new register users on week 3. Registration week is week 1.",
                          "explainCn": "3周留存=xx注册日期第3周存留用户数/xx注册周新注册用户数，注册周是第一周。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "w4",
                          "reqMetricKey": "w4",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 90,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "W4",
                          "cnName": "4周留存",
                          "explainEn": "The retention rate of new register users on week 4. Registration week is week 1.",
                          "explainCn": "4周留存=xx注册日期第4周存留用户数/xx注册周新注册用户数，注册周是第一周。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "active_retention_w2",
                          "reqMetricKey": "active_retention_w2",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 260,
                          "enWidth": 200,
                          "cnWidth": 140,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 180,
                          "enName": "Active Retention W2",
                          "cnName": "活跃次周留存",
                          "explainEn": "Active retention W2 = the percentage of players that played the game on this day and returned to the game 2 weeks later, Active date is W0.",
                          "explainCn": "W2 活跃留存率 = 首次玩了游戏的活跃玩家在2周后返回游戏的比例，其中活跃日期为 W0。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "active_retention_w3",
                          "reqMetricKey": "active_retention_w3",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 260,
                          "enWidth": 200,
                          "cnWidth": 140,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 180,
                          "enName": "Active Retention W3",
                          "cnName": "活跃3周留存",
                          "explainEn": "Active retention W3 = the percentage of players that played the game on this day and returned to the game 3 weeks later, Active date is W0.",
                          "explainCn": "W3 活跃留存率 = 首次玩了游戏的活跃玩家在3周后返回游戏的比例，其中活跃日期为 W0。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "active_retention_w4",
                          "reqMetricKey": "active_retention_w4",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 260,
                          "enWidth": 200,
                          "cnWidth": 140,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 180,
                          "enName": "Active Retention W4",
                          "cnName": "活跃4周留存",
                          "explainEn": "Active retention W4 = the percentage of players that played the game on this day and returned to the game 4 weeks later, Active date is W0.",
                          "explainCn": "W4 活跃留存率 = 首次玩了游戏的活跃玩家在4周后返回游戏的比例，其中活跃日期为 W0。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "paid_users",
                          "reqMetricKey": "paid_users",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 100,
                          "cnWidth": 100,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "Payer",
                          "cnName": "付费人数",
                          "explainEn": "Total number of users who have payment behaviors in the statistical period (vopenid deduplicated).",
                          "explainCn": "统计周期内产生流水行为的去重用户总数（vopenid数去重）。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "payer_rate",
                          "reqMetricKey": "payer_rate",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 76,
                          "cnWidth": 96,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "Payer%",
                          "cnName": "付费渗透率",
                          "explainEn": "Number of paying users/Number of active users during the statistical period.",
                          "explainCn": "付费渗透率=统计周期内消费用户数/活跃用户数。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "arpu",
                          "reqMetricKey": "arpu",
                          "enPercentWidth": 170,
                          "cnPercentWidth": 170,
                          "enWidth": 96,
                          "cnWidth": 126,
                          "enContrastWidth": 170,
                          "cnContrastWidth": 170,
                          "enName": "ARPU($)",
                          "cnName": "活跃ARPU($)",
                          "explainEn": "Average Revenue Per Active Users.Consumption amount/Number of active users in the statistical period.",
                          "explainCn": "活跃ARPU($)=统计周期内消费额/活跃用户数。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "arppu",
                          "reqMetricKey": "arppu",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 106,
                          "cnWidth": 170,
                          "enContrastWidth": 180,
                          "cnContrastWidth": 180,
                          "enName": "ARPPU($)",
                          "cnName": "付费ARPPU($)",
                          "explainEn": "Average Revenue Per Paid Users.Consumption amount/Number of payers during the statistical period.",
                          "explainCn": "平均每付费用户收入。在统计期间内的消费金额/付费人数。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_paid_users",
                          "reqMetricKey": "new_paid_users",
                          "enPercentWidth": 240,
                          "cnPercentWidth": 200,
                          "enWidth": 144,
                          "cnWidth": 126,
                          "enContrastWidth": 240,
                          "cnContrastWidth": 200,
                          "enName": "First-time Payer",
                          "cnName": "首次付费用户",
                          "explainEn": "The number of users who have payment behaviors for the first time in the statistical period.",
                          "explainCn": "在游戏内首次发生付费行为的玩家数",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_pay_amount",
                          "reqMetricKey": "new_pay_amount",
                          "enPercentWidth": 300,
                          "cnPercentWidth": 180,
                          "enWidth": 220,
                          "cnWidth": 165,
                          "enContrastWidth": 300,
                          "cnContrastWidth": 180,
                          "enName": "Revenue(first-time payer)",
                          "cnName": "首次付费用户金额",
                          "explainEn": "Amount actually paid by first-time payer in the statistical period.",
                          "explainCn": "统计周期内的首次付费用户产生的所有付费金额。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_arppu",
                          "reqMetricKey": "new_arppu",
                          "enPercentWidth": 310,
                          "cnPercentWidth": 240,
                          "enWidth": 240,
                          "cnWidth": 200,
                          "enContrastWidth": 310,
                          "cnContrastWidth": 240,
                          "enName": "First-time Payer ARPPU($)",
                          "cnName": "首次付费用户ARPPU($)",
                          "explainEn": "Consumption amount of first-time payer/Number of first-time payer during the statistical period.",
                          "explainCn": "首次付费用户ARPPU($)=统计周期内首次付费用户的消费额/首次付费用户数。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "alc",
                          "reqMetricKey": "alc",
                          "enPercentWidth": 230,
                          "cnPercentWidth": 150,
                          "enWidth": 160,
                          "cnWidth": 140,
                          "enContrastWidth": 230,
                          "cnContrastWidth": 150,
                          "enName": "Sessions per user",
                          "cnName": "平均登录次数",
                          "explainEn": "Sessions per user.\nDaily：Sum of the number of times all users have entered the game on that day/Players logged in the game on the day.\nWeekly：Sum of the number of times all users have entered the game on that week/Players logged in the game on the week.\nMonthly: Sum of the number of times all users have entered the game on that month/Players logged in the game on the month.",
                          "explainCn": "日：平均登录次数=当日所有用户进入游戏次数总和/当日活跃用户。\n周：平均登录次数=当周所有用户进入游戏次数总和/当周活跃用户。\n月：平均登录次数=当月所有用户进入游戏次数总和/当月活跃用户",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "retention_users",
                          "reqMetricKey": "retention_users",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 140,
                          "enWidth": 210,
                          "cnWidth": 171,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 140,
                          "enName": "WAU Retention Users",
                          "cnName": "周活留存",
                          "explainEn": "The number of users who logged in last week and have logged in to the game during the statistical period (deduplicated).",
                          "explainCn": "周活跃构成中的留存用户数，统计周期前一个周期（上周）登录了游戏并且在统计周期当期也有登录的用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "churn_users",
                          "reqMetricKey": "churn_users",
                          "enPercentWidth": 190,
                          "cnPercentWidth": 140,
                          "enWidth": 114,
                          "cnWidth": 95,
                          "enContrastWidth": 190,
                          "cnContrastWidth": 140,
                          "enName": "Churn Users",
                          "cnName": "周流失",
                          "explainEn": "Daily: The number of users who logged in yesterday but did not log in today.\nWeekly: The number of users who logged in last week but did not log in this week.\nMonthly: The number of users who logged in last month but did not log in this month.",
                          "explainCn": "日：昨天登录了并且在今天未登录的用户数\n周：上周登录了并且在本周未登录的用户数n月：上个月登录了并且在本月未登录的用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "churn_rate",
                          "reqMetricKey": "churn_rate",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 80,
                          "cnWidth": 95,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "Churn%",
                          "cnName": "流失率",
                          "explainEn": "Daily: Churn Users / Active Users Yesterday.\nWeekly: Churn Users / Active Users Last Week.\nMonthly: Churn Users / Active Users Last Month.",
                          "explainCn": "日=日流失用户/昨日的活跃用户\n周=周流失用户/上周的活跃用户\n月=月流失用户/上月的活跃用户。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "return_users",
                          "reqMetricKey": "return_users",
                          "enPercentWidth": 250,
                          "cnPercentWidth": 140,
                          "enWidth": 170,
                          "cnWidth": 95,
                          "enContrastWidth": 250,
                          "cnContrastWidth": 140,
                          "enName": "WAU Return Users",
                          "cnName": "周回流",
                          "explainEn": "Daily Return = Daily Active - Daily Retained - Daily New.\nWeekly Return = Weekly Active - Weekly Retained - Weekly New.\nMonthly Return = Monthly Active - Monthly Retained - Monthly New.",
                          "explainCn": "日回流=日活跃-日新进-日留存\n周回流=周活跃-周新进-周留存\n月回流=月活跃-月新进-月留存。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_w2",
                          "reqMetricKey": "weighted_w2",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 122,
                          "cnWidth": 106,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted W2",
                          "cnName": "加权次周留存",
                          "explainEn": "Week 2 weighted retention ratio, which refers to the sum of (number of newly-registered users * week 2 retention ratio) from the game launching week to the statistical week/the sum of the number of newly-registered users from the game launching week to the statistical week.",
                          "explainCn": "加权次周留存=游戏上线之周起至统计周对（新注册用户数*新增次周留存率）求和/游戏上线之周起至统计周新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "weighted_w3",
                          "reqMetricKey": "weighted_w3",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 122,
                          "cnWidth": 106,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted W3",
                          "cnName": "加权3周留存",
                          "explainEn": "Week 3 weighted retention ratio, which refers to the sum of (number of newly-registered users * week 3 retention ratio) from the game launching week to the statistical week/the sum of the number of newly-registered users from the game launching week to the statistical week.",
                          "explainCn": "加权3周留存=游戏上线之周起至统计周对（新注册用户数*新增3周留存率）求和/游戏上线之周起至统计周新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_w4",
                          "reqMetricKey": "weighted_w4",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 122,
                          "cnWidth": 106,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted W4",
                          "cnName": "加权4周留存",
                          "explainEn": "Week 4 weighted retention ratio, which refers to the sum of (number of newly-registered users * week 4 retention ratio) from the game launching week to the statistical week/the sum of the number of newly-registered users from the game launching week to the statistical week.",
                          "explainCn": "加权4周留存=游戏上线之周起至统计周对（新注册用户数*新增4周留存率）求和/游戏上线之周起至统计周新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        }
                      ]
                    },
                    {
                      "Month": [
                        {
                          "metricKey": "total_users",
                          "reqMetricKey": "total_users",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "TNU",
                          "cnName": "总注册用户数",
                          "explainEn": "Total New Users. Total number of registered users accumulated to the statistical day (vopenid deduplicated).",
                          "explainCn": "累计至统计日的注册用户总数(vopenid数去重)。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_users",
                          "reqMetricKey": "new_users",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "New",
                          "cnName": "新进用户",
                          "explainEn": "New Register Users.Total number of newly-registered users in the statistical period (vopenid deduplicated).",
                          "explainCn": "统计周期内新注册用户数(vopenid数去重)。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "avg_new_users",
                          "reqMetricKey": "avg_new_users",
                          "enPercentWidth": 210,
                          "cnPercentWidth": 210,
                          "enWidth": 136,
                          "cnWidth": 160,
                          "enContrastWidth": 210,
                          "cnContrastWidth": 210,
                          "enName": "Avg.Daily New",
                          "cnName": "平均每日新进用户",
                          "explainEn": "Average number of daily newly-registered users in the statistical period.",
                          "explainCn": "统计周期内平均每日新注册用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "active_users",
                          "reqMetricKey": "active_users",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "MAU",
                          "cnName": "月活跃",
                          "explainEn": "Monthly Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).",
                          "explainCn": "统计周期内登录过游戏的用户数(vopenid数去重)。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "avg_active_users",
                          "reqMetricKey": "avg_active_users",
                          "enPercentWidth": 220,
                          "cnPercentWidth": 200,
                          "enWidth": 150,
                          "cnWidth": 120,
                          "enContrastWidth": 220,
                          "cnContrastWidth": 200,
                          "enName": "Month Avg.DAU",
                          "cnName": "月平均日活跃",
                          "explainEn": "Average number of daily users who have logged in to the game during the statistical period.",
                          "explainCn": "统计周期内平均每日登录过游戏的用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "pay_amount",
                          "reqMetricKey": "pay_amount",
                          "enPercentWidth": 210,
                          "cnPercentWidth": 210,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 210,
                          "cnContrastWidth": 210,
                          "enName": "Revenue($)",
                          "cnName": "付费金额($)",
                          "explainEn": "Total player payment amount in statistical period, which does not include refund data, used the exchange rate from last-month settlement. This amount will deviate from the actual settlement of accounts this month for about 5% to 30%, due to the difference in exchange rate, timezone, billing amount. Please take note.",
                          "explainCn": "统计周期内玩家的付费金额总额，注：此收入不含退款数据，且采用汇率为财务上一月结算汇率，与实际财务结算会在汇率、时区、计费金额等情况上会有误差，误差在5%-30%不等，请知悉。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "avg_pay_amount",
                          "reqMetricKey": "avg_pay_amount",
                          "enPercentWidth": 280,
                          "cnPercentWidth": 210,
                          "enWidth": 210,
                          "cnWidth": 150,
                          "enContrastWidth": 280,
                          "cnContrastWidth": 210,
                          "enName": "Month Avg.Revenue($)",
                          "cnName": "月平均付费金额($)",
                          "explainEn": "Count the average monthly amount actually paid by the current players in the statistical period.",
                          "explainCn": "统计周期内玩家平均每月的实际付费金额总额",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "pcu",
                          "reqMetricKey": "pcu",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "PCU",
                          "cnName": "最高同时在线",
                          "explainEn": "The highest number of users online simultaneously at each moment (every 5 minutes) of the day.",
                          "explainCn": "取当天各时刻（每5分钟打点）最高的同时在线用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "acu",
                          "reqMetricKey": "acu",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 140,
                          "cnWidth": 140,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "ACU",
                          "cnName": "平均同时在线",
                          "explainEn": "The average number of users online simultaneously at each moment (every 5 minutes) of the day.",
                          "explainCn": "将当天内各时刻（每5分钟打点）的在线数进行平均统计。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "aot",
                          "reqMetricKey": "aot",
                          "enPercentWidth": 240,
                          "cnPercentWidth": 220,
                          "enWidth": 164,
                          "cnWidth": 190,
                          "enContrastWidth": 240,
                          "cnContrastWidth": 220,
                          "enName": "Avg.Playtime(min)",
                          "cnName": "平均在线时长(分钟)",
                          "explainEn": "Daily: Daily Average Play Time.Total play time/Number of active users (min).\nWeekly: Weekly Average Play Time. Total play time/Weekly active users (min).\nMonthly: Monthly Average Play Time. Total play time/Monthly active users (min).",
                          "explainCn": "日平均在线时长=总在线时长/活跃用户数（单位：分钟\n周平均在线时长=周总在线时长/周活跃用户数（单位：分钟\n月平均在线时长=月总在线时长/月活跃用户数（单位：分钟）",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "m2",
                          "reqMetricKey": "m2",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 90,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "M2",
                          "cnName": "次月留存",
                          "explainEn": "The retention rate of new register users on month 2. Number of retained users on month N from XX (registration date) / Number of new users on XX (registration month). Registration month is month 1.",
                          "explainCn": "次次月留存=xx注册日期第2月存留用户数/xx注册月新注册用户数，注册月是第一月。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "m3",
                          "reqMetricKey": "m3",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 90,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "M3",
                          "cnName": "3月留存",
                          "explainEn": "The retention rate of new register users on month 3. Registration month is month 1.",
                          "explainCn": "3月留存=xx注册日期第3月存留用户数/xx注册月新注册用户数，注册月是第一月。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "m4",
                          "reqMetricKey": "m4",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 90,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "M4",
                          "cnName": "4月留存",
                          "explainEn": "The retention rate of new register users on month 4. Registration month is month 1.",
                          "explainCn": "4月留存=xx注册日期第4月存留用户数/xx注册月新注册用户数，注册月是第一月。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "active_retention_m2",
                          "reqMetricKey": "active_retention_m2",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 260,
                          "enWidth": 200,
                          "cnWidth": 140,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 180,
                          "enName": "Active Retention M2",
                          "cnName": "活跃次月留存",
                          "explainEn": "Active retention M2 = the percentage of players that played the game on this day and returned to the game 2 months later, Active date is M0.",
                          "explainCn": "M2 活跃留存率 = 首次玩了游戏的活跃玩家在2月后返回游戏的比例，其中活跃日期为 M0。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "active_retention_m3",
                          "reqMetricKey": "active_retention_m3",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 260,
                          "enWidth": 200,
                          "cnWidth": 140,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 180,
                          "enName": "Active Retention M3",
                          "cnName": "活跃3月留存",
                          "explainEn": "Active retention M3 = the percentage of players that played the game on this day and returned to the game 3 months later, Active date is M0.",
                          "explainCn": "M3 活跃留存率 = 首次玩了游戏的活跃玩家在3月后返回游戏的比例，其中活跃日期为 M0。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "active_retention_m4",
                          "reqMetricKey": "active_retention_m4",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 260,
                          "enWidth": 200,
                          "cnWidth": 140,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 180,
                          "enName": "Active Retention M4",
                          "cnName": "活跃4月留存",
                          "explainEn": "Active retention M4 = the percentage of players that played the game on this day and returned to the game 4 months later, Active date is M0.",
                          "explainCn": "M4 活跃留存率 = 首次玩了游戏的活跃玩家在4月后返回游戏的比例，其中活跃日期为 M0。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "paid_users",
                          "reqMetricKey": "paid_users",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 100,
                          "cnWidth": 100,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "Payer",
                          "cnName": "付费人数",
                          "explainEn": "Total number of users who have payment behaviors in the statistical period (vopenid deduplicated).",
                          "explainCn": "统计周期内产生流水行为的去重用户总数（vopenid数去重）。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "payer_rate",
                          "reqMetricKey": "payer_rate",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 76,
                          "cnWidth": 96,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "Payer%",
                          "cnName": "付费渗透率",
                          "explainEn": "Number of paying users/Number of active users during the statistical period.",
                          "explainCn": "付费渗透率=统计周期内消费用户数/活跃用户数。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "arpu",
                          "reqMetricKey": "arpu",
                          "enPercentWidth": 170,
                          "cnPercentWidth": 170,
                          "enWidth": 96,
                          "cnWidth": 126,
                          "enContrastWidth": 170,
                          "cnContrastWidth": 170,
                          "enName": "ARPU($)",
                          "cnName": "活跃ARPU($)",
                          "explainEn": "Average Revenue Per Active Users.Consumption amount/Number of active users in the statistical period.",
                          "explainCn": "活跃ARPU($)=统计周期内消费额/活跃用户数。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "arppu",
                          "reqMetricKey": "arppu",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 106,
                          "cnWidth": 170,
                          "enContrastWidth": 180,
                          "cnContrastWidth": 180,
                          "enName": "ARPPU($)",
                          "cnName": "付费ARPPU($)",
                          "explainEn": "Average Revenue Per Paid Users.Consumption amount/Number of payers during the statistical period.",
                          "explainCn": "平均每付费用户收入。在统计期间内的消费金额/付费人数。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_paid_users",
                          "reqMetricKey": "new_paid_users",
                          "enPercentWidth": 240,
                          "cnPercentWidth": 200,
                          "enWidth": 144,
                          "cnWidth": 126,
                          "enContrastWidth": 240,
                          "cnContrastWidth": 200,
                          "enName": "First-time Payer",
                          "cnName": "首次付费用户",
                          "explainEn": "The number of users who have payment behaviors for the first time in the statistical period.",
                          "explainCn": "在游戏内首次发生付费行为的玩家数",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_pay_amount",
                          "reqMetricKey": "new_pay_amount",
                          "enPercentWidth": 300,
                          "cnPercentWidth": 180,
                          "enWidth": 220,
                          "cnWidth": 165,
                          "enContrastWidth": 300,
                          "cnContrastWidth": 180,
                          "enName": "Revenue(first-time payer)",
                          "cnName": "首次付费用户金额",
                          "explainEn": "Amount actually paid by first-time payer in the statistical period.",
                          "explainCn": "统计周期内的首次付费用户产生的所有付费金额。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_arppu",
                          "reqMetricKey": "new_arppu",
                          "enPercentWidth": 310,
                          "cnPercentWidth": 240,
                          "enWidth": 240,
                          "cnWidth": 200,
                          "enContrastWidth": 310,
                          "cnContrastWidth": 240,
                          "enName": "First-time Payer ARPPU($)",
                          "cnName": "首次付费用户ARPPU($)",
                          "explainEn": "Consumption amount of first-time payer/Number of first-time payer during the statistical period.",
                          "explainCn": "首次付费用户ARPPU($)=统计周期内首次付费用户的消费额/首次付费用户数。",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "alc",
                          "reqMetricKey": "alc",
                          "enPercentWidth": 230,
                          "cnPercentWidth": 150,
                          "enWidth": 160,
                          "cnWidth": 140,
                          "enContrastWidth": 230,
                          "cnContrastWidth": 150,
                          "enName": "Sessions per user",
                          "cnName": "平均登录次数",
                          "explainEn": "Sessions per user.\nDaily：Sum of the number of times all users have entered the game on that day/Players logged in the game on the day.\nWeekly：Sum of the number of times all users have entered the game on that week/Players logged in the game on the week.\nMonthly: Sum of the number of times all users have entered the game on that month/Players logged in the game on the month.",
                          "explainCn": "日：平均登录次数=当日所有用户进入游戏次数总和/当日活跃用户。\n周：平均登录次数=当周所有用户进入游戏次数总和/当周活跃用户。\n月：平均登录次数=当月所有用户进入游戏次数总和/当月活跃用户",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "retention_users",
                          "reqMetricKey": "retention_users",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 140,
                          "enWidth": 210,
                          "cnWidth": 171,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 140,
                          "enName": "MAU Retention Users",
                          "cnName": "月活留存",
                          "explainEn": "The number of users who logged in last month and have logged in to the game during the statistical period (deduplicated).",
                          "explainCn": "月活跃构成中的留存用户数，统计周期前一个周期（上月）登录了游戏并且在统计周期当期也有登录的用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "churn_users",
                          "reqMetricKey": "churn_users",
                          "enPercentWidth": 190,
                          "cnPercentWidth": 140,
                          "enWidth": 114,
                          "cnWidth": 95,
                          "enContrastWidth": 190,
                          "cnContrastWidth": 140,
                          "enName": "Churn Users",
                          "cnName": "月流失",
                          "explainEn": "Daily: The number of users who logged in yesterday but did not log in today.\nWeekly: The number of users who logged in last week but did not log in this week.\nMonthly: The number of users who logged in last month but did not log in this month.",
                          "explainCn": "日：昨天登录了并且在今天未登录的用户数\n周：上周登录了并且在本周未登录的用户数n月：上个月登录了并且在本月未登录的用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "churn_rate",
                          "reqMetricKey": "churn_rate",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 80,
                          "cnWidth": 95,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "Churn%",
                          "cnName": "流失率",
                          "explainEn": "Daily: Churn Users / Active Users Yesterday.\nWeekly: Churn Users / Active Users Last Week.\nMonthly: Churn Users / Active Users Last Month.",
                          "explainCn": "日=日流失用户/昨日的活跃用户\n周=周流失用户/上周的活跃用户\n月=月流失用户/上月的活跃用户。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "return_users",
                          "reqMetricKey": "return_users",
                          "enPercentWidth": 250,
                          "cnPercentWidth": 140,
                          "enWidth": 170,
                          "cnWidth": 95,
                          "enContrastWidth": 250,
                          "cnContrastWidth": 140,
                          "enName": "MAU Return Users",
                          "cnName": "月回流",
                          "explainEn": "Daily Return = Daily Active - Daily Retained - Daily New.\nWeekly Return = Weekly Active - Weekly Retained - Weekly New.\nMonthly Return = Monthly Active - Monthly Retained - Monthly New.",
                          "explainCn": "日回流=日活跃-日新进-日留存\n周回流=周活跃-周新进-周留存\n月回流=月活跃-月新进-月留存。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_m2",
                          "reqMetricKey": "weighted_m2",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 122,
                          "cnWidth": 106,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted M2",
                          "cnName": "加权次月留存",
                          "explainEn": "Month 2 weighted retention ratio, which refers to the sum of (number of newly-registered users * month 2 retention ratio) from the game launching month to the statistical month/the sum of the number of newly-registered users from the game launching month to the statistical month.",
                          "explainCn": "加权次月留存=游戏上线之月起至统计月对（新注册用户数*新增次月留存率）求和/游戏上线之月起至统计月新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "weighted_m3",
                          "reqMetricKey": "weighted_m3",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 122,
                          "cnWidth": 106,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted M3",
                          "cnName": "加权3月留存",
                          "explainEn": "Month 3 weighted retention ratio, which refers to the sum of (number of newly-registered users * month 3 retention ratio) from the game launching month to the statistical month/the sum of the number of newly-registered users from the game launching month to the statistical month.",
                          "explainCn": "加权3月留存=游戏上线之月起至统计月对（新注册用户数*新增3月留存率）求和/游戏上线之月起至统计月新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_m4",
                          "reqMetricKey": "weighted_m4",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 122,
                          "cnWidth": 106,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted M4",
                          "cnName": "加权4月留存",
                          "explainEn": "Month 4 weighted retention ratio, which refers to the sum of (number of newly-registered users * month 4 retention ratio) from the game launching month to the statistical month/the sum of the number of newly-registered users from the game launching month to the statistical month.",
                          "explainCn": "加权4月留存=游戏上线之月起至统计月对（新注册用户数*新增4月留存率）求和/游戏上线之月起至统计月新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        }
                      ]
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ]
};